module.exports = __webpack_public_path__ + "static/media/Montserrat-RegularItalic.a7063e0c.ttf";